import { DayOfWeek, Meal, MealOfDay, MealPlanData, MealPlanWithMeals } from 'fitbeat.models';

export class NutritionSerializer {
  public static serializeMealPlanData(mealPlanData: MealPlanData): any {
    const returnObject = JSON.parse(JSON.stringify(mealPlanData));
    const mealIdSchedule = this.serializeMealIdSchedule(mealPlanData.mealIdSchedule);
    returnObject.mealIdSchedule = mealIdSchedule;
    return returnObject;
  }

  public static serializeMealPlanWithMeals(mealPlanWithMeal: MealPlanWithMeals): any {
    const returnObject = JSON.parse(JSON.stringify(mealPlanWithMeal));
    const mealIdSchedule = this.serializeMealIdSchedule(mealPlanWithMeal.mealIdSchedule);
    const mealSchedule = this.serializeMealSchedule(mealPlanWithMeal.mealSchedule);
    const carbsForDay = this.serializeMealMacros(mealPlanWithMeal.carbsForDay);
    const fatForDay = this.serializeMealMacros(mealPlanWithMeal.fatForDay);
    const proteinForDay = this.serializeMealMacros(mealPlanWithMeal.proteinForDay);
    returnObject.mealIdSchedule = mealIdSchedule;
    returnObject.mealSchedule = mealSchedule;
    returnObject.carbsForDay = carbsForDay;
    returnObject.fatForDay = fatForDay;
    returnObject.proteinForDay = proteinForDay;
    return returnObject;
  }

  public static deserializeMealPlanData(mealPlanData: any): MealPlanData {
    const returnObject = Object.assign(new MealPlanData(), mealPlanData);
    returnObject.mealIdSchedule = this.deserializeMealIdSchedule(returnObject.mealIdSchedule);
    return returnObject;
  }

  public static deserializeMealPlanWithMeals(mealPlanWithMeals: MealPlanWithMeals): MealPlanWithMeals {
    const returnObject = Object.assign(new MealPlanWithMeals(), mealPlanWithMeals);
    returnObject.mealIdSchedule = this.deserializeMealIdSchedule(returnObject.mealIdSchedule);
    returnObject.mealSchedule = this.deserializeMealSchedule(returnObject.mealSchedule);
    returnObject.carbsForDay = this.deserializeMealMacros(returnObject.carbsForDay);
    returnObject.fatForDay = this.deserializeMealMacros(returnObject.fatForDay);
    returnObject.proteinForDay = this.deserializeMealMacros(returnObject.proteinForDay);
    return returnObject;
  }

  private static serializeMealMacros(macros: Map<DayOfWeek, number>) {
    const serializedMacros = {};
    macros.forEach((total, dayOfWeek) => {
      serializedMacros[dayOfWeek] = total;
    });
    return serializedMacros;
  }

  private static deserializeMealMacros(macros: any) {
    const deserializedMacros: Map<DayOfWeek, number> = new Map<DayOfWeek, number>();
    Object.keys(macros).forEach((dayOfWeek ) => {
      deserializedMacros.set(DayOfWeek[dayOfWeek], macros[dayOfWeek]);
    });
    return deserializedMacros;
  }

  private static serializeMealIdSchedule(mealIdSchedule: Map<DayOfWeek, Map<MealOfDay, string>>): any {
    const mealSchedule = {};
    mealIdSchedule.forEach((mealOfDay, dayOfWeekKey) => {
      const mealForDay = {};
      mealOfDay.forEach((meal, mealOfDayKey) => {
        mealForDay[mealOfDayKey] = meal;
      });
      mealSchedule[dayOfWeekKey] = mealForDay;
    });

    return mealSchedule;
  }

  private static deserializeMealIdSchedule(mealIdSchedule: any): Map<DayOfWeek, Map<MealOfDay, string>> {
    const mealSchedule = new Map<DayOfWeek, Map<MealOfDay, string>>();
    Object.keys(mealIdSchedule).forEach((dayOfWeekKey) => {
      const mealForDay = new Map<MealOfDay, string>();
      Object.keys(mealIdSchedule[DayOfWeek[dayOfWeekKey]]).forEach((mealOfDayKey) => {
        mealForDay.set(MealOfDay[mealOfDayKey], mealIdSchedule[dayOfWeekKey][mealOfDayKey]);
      });
      mealSchedule.set(DayOfWeek[dayOfWeekKey], mealForDay);
    });

    return mealSchedule;
  }

  private static serializeMealSchedule(mealSchedule: Map<DayOfWeek, Map<MealOfDay, Meal>>): any {
    const objectMealSchedule = {};
    mealSchedule.forEach((mealOfDay, dayOfWeekKey) => {
      const mealForDay = {};
      mealOfDay.forEach((meal, mealOfDayKey) => {
        mealForDay[mealOfDayKey] = meal;
      });
      objectMealSchedule[dayOfWeekKey] = mealForDay;
    });

    return objectMealSchedule;
  }

  private static deserializeMealSchedule(mealSchedule: any): Map<DayOfWeek, Map<MealOfDay, Meal>> {
    const mapMealSchedule = new Map<DayOfWeek, Map<MealOfDay, Meal>>();
    Object.keys(mealSchedule).forEach((dayOfWeekKey) => {
      const mealForDay = new Map<MealOfDay, Meal>();
      Object.keys(mealSchedule[DayOfWeek[dayOfWeekKey]]).forEach((mealOfDayKey) => {
        mealForDay.set(MealOfDay[mealOfDayKey], mealSchedule[dayOfWeekKey][mealOfDayKey]);
      });
      mapMealSchedule.set(DayOfWeek[dayOfWeekKey], mealForDay);
    });

    return mapMealSchedule;
  }
}
